

export const RenderIf = (props:{
    if:boolean;
    else?:JSX.Element;
    children:JSX.Element;
})=>{
    if (props.if){
        return props.children;
    }
    return props.else??null;
};